import React, { useEffect } from 'react';
import Head from 'next/head';

const infobipElements = [
  '#infobip-script',
  '#ib-button-messaging',
  '.ib-widget-wrapper',
  'script[src="https://livechat.infobip.com/widget.js"]',
];

export const removeInfobipElemets = () => {
  clearLocalStorage();

  infobipElements.forEach((query) => {
    document.querySelector(query)?.remove();
  });
};

export const clearLocalStorage = () => {
  const tmp = localStorage.getItem('persist:root');
  const tmp2 = localStorage.getItem('lastOpenedProjectId');
  localStorage.clear();
  localStorage.setItem('persist:root', tmp);
  localStorage.setItem('lastOpenedProjectId', tmp2);
};

const InfobipWidget: React.FC<{ id: string }> = ({ id }) => {
  useEffect(() => {
    clearLocalStorage();
  }, []);

  return (
    <Head>
      <script>localStorage.clear();</script>

      <script
        id="infobip-script"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
(function(I,n,f,o,b,i,p){
I[b]=I[b]||function(){(I[b].q=I[b].q||[]).push(arguments)};
I[b].t=1*new Date();i=n.createElement(f);i.async=1;i.src=o;
p=n.getElementsByTagName(f)[0];p.parentNode.insertBefore(i,p)})
(window,document,'script','https://livechat.infobip.com/widget.js','liveChat');
liveChat('init', '${id}');`,
        }}
      />
    </Head>
  );
};

export default InfobipWidget;
